import { makeStyles } from '@material-ui/core';

export default makeStyles(
  theme => ({
    formColumn: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexFlow: 'column nowrap',
    },
    formLabel: {
      display: 'block',
      color: theme.palette.primary.main,
      opacity: 0.5,
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(16),
      textTransform: 'uppercase',
      letterSpacing: '0.2px',
      minWidth: 280,
      textAlign: 'left',
      marginBottom: 4,
    },
    inputWrap: {
      width: '100%',
      minHeight: 60,
    },
    formInput: {
      width: '100%',
      opacity: 1,
      backgroundColor: theme.palette.white,
      '&:focus': {
        border: [2, 'solid', theme.palette.secondary.main],
      },
    },
    divider: {
      marginBottom: 40,
    },
    visibilityButtonsContainer: {
      opacity: 0.5,
    },
  }),
  { name: 'FormRowInput' },
);
